import React, {Component} from 'react'
import styled from "styled-components"
import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import {SettlementCard, SettlementPadding} from "manager/views/components/Settlement/Common/SettlementCard"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import {
  selectSearchConfig,
  selectSearchResults,
  selectSearchResultsPending
} from "manager/selectors/settlement_provider_search_selectors"
import {
  DESKTOP_BREAKPOINT,
} from "manager/views/components/Settlement/constants"
import {
  selectAgentOpId,
  selectAssignmentTransactionHash,
  selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {createSettlementProviderSelection} from "manager/redux/referral"
import {segmentEventTracker} from "common/analytics"


const SearchResultContainer = styled(SettlementMaxWidth)`
  display: flex;
  flex-direction: column;
  @media screen and ${DESKTOP_BREAKPOINT} {
    margin-bottom: 60px;
  }
`

const Header = styled(SettlementPadding)`
`
const Body = styled(SettlementCard)`
`

const HeaderRow = styled.div`
  display: none;
  @media screen and ${DESKTOP_BREAKPOINT} {
    display: flex;
    margin-top: 24px;
    margin-bottom: -12px;
    font-size: 12px;
    line-height: 15px;
  }
`
const Row = styled.div`
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  :not(:last-child) {
    border-bottom: 1px solid #D9D9D9;
  }
`
const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 80%;
  margin-right: auto;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex-direction: row;
    flex: 0 0 94%;  
  }
`
const Col1 = styled.div`
  flex-basis: auto;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex: 0 0 40%;
  }
`
const Col2 = styled.div`
  flex-basis: auto;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex: 0 0 37%;
  }
`
const Col3 = styled.div`
  flex-basis: auto;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex: 0 0 23%;
  }
`
const Col4 = styled.a`
  text-align: right;
`

const LoadingBlock = styled.div`
  height: 14px;
  width: 176px;
  background: linear-gradient(241deg, white, #f1f1f4);
  background-size: 400% 400%;
  animation: loading 1s ease-out infinite;
  @keyframes loading {
      0%{background-position:76% 0%}
      50%{background-position:25% 100%}
      100%{background-position:76% 0%}
  }
  margin-bottom:15px;
}
`

const ResultRow = ({id, name, flat_address, address_line_1, city, state, zipcode, distance_from_addr, selectQualiaProvider}) => (
  <Row>
    <ColWrapper>
      <Col1 style={{fontWeight: 'bold'}}>{name}</Col1>
      <Col2>
        <div>{address_line_1}</div>
        <div>{city && city + ', '} {state} {' '} {zipcode}</div>
      </Col2>
      <Col3
        style={{color: '#8C8C8C'}}>{distance_from_addr && (distance_from_addr).toFixed(distance_from_addr < 10 ? 1 : 0) + ' mi'}</Col3>
    </ColWrapper>
    <Col4 data-testid="provider-select" onClick={()=>{selectQualiaProvider(name, flat_address, id, distance_from_addr)}}>Select</Col4>
  </Row>
)

const LoadingRow = () => (
  <Row>
    <ColWrapper>
      <Col1><LoadingBlock/></Col1>
      <Col2><LoadingBlock/></Col2>
      <Col3><LoadingBlock style={{width: '48px'}}/></Col3>
    </ColWrapper>
  </Row>
)

class ProviderSearchResults extends Component {
  state = {
    canEmitAnotherScrollEvent: true
  }

  sendScrollEventToSegment = _.debounce(() => {
    this.setState((state, props) => {
      if (state.canEmitAnotherScrollEvent) {
        const {transaction_op_id, agent_op_id} = props
        segmentEventTracker('Qualia-Provider Search Results Scrolled', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
      }
      return {canEmitAnotherScrollEvent: false}
    })
  }, 500)

  componentDidMount() {
    window.addEventListener('scroll', this.sendScrollEventToSegment, {capture: true})
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchResults !== prevProps.searchResults) {
      this.setState({canEmitAnotherScrollEvent: true})
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.sendScrollEventToSegment, {capture: true})
  }

  selectQualiaProvider = (agency_name, agency_address, agency_id, distance_from_search_origin) => {
    const {dispatch, hash, searchConfig, transaction_op_id, agent_op_id} = this.props
    dispatch(createSettlementProviderSelection(
      hash,
      agency_name,
      {...searchConfig},
      agency_address,
      agency_id,
      distance_from_search_origin
    ))
    segmentEventTracker('Qualia-Provider Selected', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
  }
  render() {
    const {searchResultsPending, searchResults} = this.props
    return (
      <SearchResultContainer>
        <Header>
          <HeaderRow>
            <ColWrapper>
              <Col1>Provider Name</Col1>
              <Col2>Address</Col2>
              <Col3>Distance</Col3>
            </ColWrapper>
          </HeaderRow>
        </Header>
        <Body>
          {searchResultsPending && _.times(3 , (i) => <LoadingRow key={i}/>)}
          {!searchResultsPending && searchResults.map(agency => (<ResultRow key={agency.id} {...agency} selectQualiaProvider={this.selectQualiaProvider}/>))}
        </Body>
      </SearchResultContainer>
    )
  }

}

const selector = createStructuredSelector({
  searchResultsPending: selectSearchResultsPending,
  hash: selectAssignmentTransactionHash,
  searchResults: selectSearchResults,
  searchConfig: selectSearchConfig,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(ProviderSearchResults)
